import { createContext } from 'react';
import type { i18n } from 'i18next';
import setupI18next from '../i18n/i18n';

export type tFunc = (x: string, y?: object) => string;

export interface TranslationContextType {
  t: tFunc;
  i18n: i18n;
}

const defaultI18n = setupI18next();

const TranslationContext = createContext<TranslationContextType>({
  t: (key) => key,
  i18n: defaultI18n,
});

export default TranslationContext;
